export const treatmentTimeMap = {
  XS: 10,
  SM: 20,
  MD: 30,
  LG: 40,
  XL: 60,
  BODY: 120,
};
